const swiperCollection = new Swiper('.collection-swiper', {
  slidesPerView: 1.65,
  loop: true,
  lazy: true,
  spaceBetween: 12,
  // freeMode: true,

  navigation: {
    nextEl: '.swiper-butt-next',
    prevEl: '.swiper-butt-prev',
  },

  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
